import { Flex, Paragraph } from 'theme-ui';

import { themed } from './Price.theme';

export const Amount = themed(
  ({ theme, compareAtPriceV2, isOnSale, priceV2 }) => {
    return (
      <Flex data-comp={Amount.displayName} sx={theme.price}>
        {isOnSale ? ( // onetime on sale
          <Flex>
            <Paragraph sx={theme.price.new}>{priceV2.locale}</Paragraph>
            <Paragraph sx={theme.price.lineThrough}>
              {compareAtPriceV2.locale}
            </Paragraph>
          </Flex>
        ) : (
          // onetime full price
          <Paragraph sx={theme.price.regular}>{priceV2.locale}</Paragraph>
        )}
      </Flex>
    );
  }
);

Amount.displayName = 'Amount';
